/**
 * Client-side checks for the job form.
 *
 * The rules mirror `docs/API.md`. The server enforces them again — this only
 * gives a faster, clearer message.
 */

export interface JobFormValues {
  name: string;
  image: string;
  command: string;
  gpus: number;
  hours: number;
}

/** Field name to error message; empty when the form is valid. */
export type JobFormErrors = Partial<Record<keyof JobFormValues, string>>;

/**
 * Validate the job form.
 *
 * Args:
 *     values: The current form values.
 *
 * Returns:
 *     One message per invalid field.
 */
export function validateJobForm(values: JobFormValues): JobFormErrors {
  const errors: JobFormErrors = {};

  if (!values.name.trim()) {
    errors.name = "Give the job a name so you can recognise it later.";
  }
  if (!values.image) {
    errors.image = "Choose an environment.";
  }
  if (!values.command.trim()) {
    errors.command = "Write the command to run.";
  }
  if (!Number.isInteger(values.gpus) || values.gpus < 1) {
    errors.gpus = "Ask for at least one GPU.";
  }
  if (!Number.isFinite(values.hours) || values.hours < 1) {
    errors.hours = "A job needs at least one hour.";
  }

  return errors;
}
